import request from '@/utils/zsm-requets'
const order = '/zsm/api/order/'
const newOrder = '/zsm/api/newOrder/'

/**
* 修改订单学习状态
* @param orderId  订单号
*/
export function updateOrderStudyFlag(orderId) {
    return request({
        url: order+'updateOrderStudyFlag',
        method: 'get',
        params:{orderId}
    })
}


/**
* 修改纯图文订单状态，并记录对应的章节内容
* @param orderId  订单号
* @param goodId  商品ID
* @param goodDetailId  商品详情id
*/
export function createGoodImageText(params) {
    return request({
        url: order+'createGoodImageText',
        method: 'post',
        params
    })
}



/**
* 订单列表
* @param frontId  前端编码
* @param mobile  手机号
* */

export function orderListData(params) {
    return request({
        url: order+'listData',
        method: 'post',
        params
    })
}
/*订单详情
* @param id  订单编号
* */

export function getOrder(params) {
    return request({
        url: order+'get',
        method: 'post',
        params
    })
}



/*订单列表
* @param frontId  前端编码
* @param mobile  手机号
* */

export function deleteOrder(id) {
    return request({
        url: order+'delete',
        method: 'post',
        params:{id}
    })
}


/*订单列表
* @param frontId  前端编码
* @param mobile  手机号
* */

export function bindDoudian(params) {
    return request({
        url: newOrder+'bindDoudian',
        method: 'post',
        params
    })
}

/**
 * 根据订单号获取赠送订单列表
 *  @param id 赠送订单id
 *  @param orderId 父订单
 *  @param pageNo 当前页
 *  @param pageSize 每页条数
 */
export function orderGiveListData(info) {
    return request({
        url: order + 'orderGiveListData',
        method: 'post',
        params: info
    })
}

/**
 * 根据赠送单id获取单个赠送单
 *  @param id 赠送订单id
 */
export function getOrderGive(id) {
    return request({
        url: order + 'getOrderGive',
        method: 'post',
        params: {id}
    })
}
